module.exports = ".odd:hover {\n  background-color: var(--api-jaune);\n  color: black;\n  text-decoration: none;\n}\n\n.even:hover {\n  background-color: var(--api-gris);\n  color: yellow;\n  text-decoration: none;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/principal/interventions/detail-intervention/detail-intervention.component.css
// module id = ./src/app/principal/interventions/detail-intervention/detail-intervention.component.css
// module chunks = main